import { Col, Container, Row } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Customer/general/CustomerSettingsheader.css'

const Customersettingsheader = ({screenName, centered = true}) => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="customer-settingsheader-wrapper">
            <Container>
                <Row className="customer-settingsheader">
                    <Col xs={2} className="customer-settingsheader-back-btn-col">
                        <button className="customer-settingsheader-back-btn" onClick={handleBack}>
                            <FaArrowLeft />
                        </button>
                    </Col>
                    <Col xs={8} className="text-center">
                        <h5 className="customer-settingsheader-title">{screenName}</h5>
                    </Col>
                    <Col xs={2}></Col>
                </Row>
            </Container>
        </div>
    );
};
export default Customersettingsheader;